import { render } from "./DockerTag.vue?vue&type=template&id=0712f1e2"
import script from "./DockerTag.vue?vue&type=script&lang=js"
export * from "./DockerTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__